import { Middleware } from './middleware'

export default {
  getSwagger() {
    return new Middleware('https://portal-back-api-qa.diazerosecurity.com.br/v3/api-docs')
      .method('GET')
      .build()
      .then(result => result.data)
  }
}